/**
 * PlanListPanel — wrapper for the PlanListView with flight plan hook.
 */
import { PlanListView } from './PlanListView';
import { useFlightPlan } from '../services/FlightPlanContext';

export function PlanListPanel() {
  const { planList, loadPlan, deletePlan, clearCurrentPlan } = useFlightPlan();
  return (
    <PlanListView
      plans={planList}
      onSelect={loadPlan}
      onDelete={deletePlan}
      onNew={clearCurrentPlan}
    />
  );
}
